/* Bhavana Handlooms — theme-settings.js (loaded after theme.js)
   Theme settings: sticky header, fade-in on scroll, cookie banner, newsletter pop-up. */
(function(){
  var htmlEl = document.documentElement;
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(fn, fallback){
    try { return fn(); } catch(e){ return fallback; }
  }

  /* ---------- sticky header ---------- */
  var siteHeader = document.querySelector('[data-header]');
  if(siteHeader && (htmlEl.classList.contains('sh-always') || htmlEl.classList.contains('sh-desktop'))){
    var headerSection = siteHeader.parentElement;
    var topbar = headerSection.querySelector('.topbar');
    var setHeaderH = function(){
      var pinned = getComputedStyle(headerSection).position === 'sticky';
      htmlEl.style.setProperty('--topbar-h', (topbar ? topbar.offsetHeight : 0) + 'px');
      htmlEl.style.setProperty('--header-h', pinned ? siteHeader.offsetHeight + 'px' : '0px');
    };
    setHeaderH();
    if(window.ResizeObserver){
      var headerRO = new ResizeObserver(setHeaderH);
      headerRO.observe(siteHeader);
      if(topbar) headerRO.observe(topbar);
    }
    window.addEventListener('resize', setHeaderH);
    var stuckTicking = false;
    var markStuck = function(){
      stuckTicking = false;
      siteHeader.classList.toggle('is-stuck', window.scrollY > 0 && siteHeader.getBoundingClientRect().top <= 0);
    };
    window.addEventListener('scroll', function(){
      if(stuckTicking) return;
      stuckTicking = true;
      requestAnimationFrame(markStuck);
    }, { passive: true });
    markStuck();
  }

  /* ---------- fade in while scrolling ---------- */
  if(htmlEl.classList.contains('has-reveal') && !reduceMotion && 'IntersectionObserver' in window){
    var revealIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealIO.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
    document.querySelectorAll('.app-main .card, .app-main .sec-head, .app-main .hero, .app-main .story, .app-main .rail, .about-section, .trust-strip').forEach(function(el){
      if(el.getBoundingClientRect().top < window.innerHeight) return; // already on screen
      el.classList.add('reveal');
      revealIO.observe(el);
    });
  }

  /* ---------- product title: whole title in two lines ---------- */
  document.querySelectorAll('.pdp-title').forEach(function(box){
    var title = box.querySelector('h1');
    var actions = box.querySelector('.pdp-title__actions');
    var codesRow = box.parentNode.querySelector('.pdp-codes');
    var priceRow = box.parentNode.querySelector('.price-row');
    // share + wishlist sit beside the SKU/barcode (or the price) so the title gets the full width
    if(actions && (codesRow || priceRow)) (codesRow || priceRow).appendChild(actions);
    else if(actions) actions.style.cssText = 'position:static;visibility:visible;display:flex;gap:8px;margin-top:8px';
    if(!title) return;
    var fit = function(){
      title.style.fontSize = '';
      var size = parseFloat(getComputedStyle(title).fontSize);
      var min = window.innerWidth >= 750 ? 17 : 14;
      var lineHeight = function(){ return parseFloat(getComputedStyle(title).lineHeight) || size * 1.28; };
      // shrink in half-pixel steps until the title takes at most two lines
      while(size > min && title.scrollHeight > lineHeight() * 2 + 2){
        size -= 0.5;
        title.style.fontSize = size + 'px';
      }
    };
    fit();
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var fitTimer;
    window.addEventListener('resize', function(){ clearTimeout(fitTimer); fitTimer = setTimeout(fit, 120); });
  });

  /* ---------- quantity can't go past the stock on hand ---------- */
  function limitNote(stepper, text){
    var row = stepper.closest('.qty-row, .line-actions') || stepper.parentNode;
    var note = row.nextElementSibling && row.nextElementSibling.classList.contains('stock-limit') ? row.nextElementSibling : null;
    if(!text){ if(note) note.hidden = true; return; }
    if(!note){
      note = document.createElement('p');
      note.className = 'stock-limit';
      note.setAttribute('role', 'status');
      row.parentNode.insertBefore(note, row.nextSibling);
    }
    note.textContent = text;
    note.hidden = false;
  }
  var pdpJson = document.querySelector('[data-product-json]');
  var pdpData = pdpJson ? store(function(){ return JSON.parse(pdpJson.textContent); }, null) : null;
  // product page: each option chip (e.g. size) shows how many are left for that choice
  var optForm = pdpData && document.querySelector('[data-product-form]');
  if(optForm){
    var optRadios = Array.prototype.slice.call(optForm.querySelectorAll('input[data-option-index]'));
    var renderOptStock = function(){
      var chosen = [];
      optRadios.forEach(function(r){ if(r.checked) chosen[+r.getAttribute('data-option-index')] = r.value; });
      optRadios.forEach(function(r){
        var idx = +r.getAttribute('data-option-index');
        var v = pdpData.variants.filter(function(x){
          return x.options[idx] === r.value && x.options.every(function(val, i){ return i === idx || chosen[i] === undefined || val === chosen[i]; });
        })[0];
        var label = optForm.querySelector('label[for="' + r.id + '"]');
        if(!label) return;
        var note = label.querySelector('.opt-stock');
        if(!note){
          note = document.createElement('small');
          note.className = 'opt-stock';
          label.appendChild(note);
          label.classList.add('has-stock');
        }
        var text = '', level = '';
        if(!v || !v.available){ text = 'Sold out'; level = 'out'; }
        else if(v.stock !== null && v.policy === 'deny'){
          text = v.stock <= 3 ? 'Only ' + v.stock + ' left' : v.stock + ' left';
          level = v.stock <= 3 ? 'low' : 'ok';
        } else { text = 'In stock'; level = 'ok'; }
        note.textContent = text;
        note.setAttribute('data-level', level);
      });
    };
    optRadios.forEach(function(r){ r.addEventListener('change', renderOptStock); });
    renderOptStock();
  }

  function stockFor(input){
    // bag: the stock is printed on the input; product page: from the chosen variant
    if(input.hasAttribute('data-available')) return +input.getAttribute('data-available');
    if(!pdpData || !input.matches('[data-quantity]')) return null;
    var form = input.closest('form');
    var idField = form && form.querySelector('[data-variant-id]');
    var id = idField ? +idField.value : 0;
    var v = pdpData.variants.filter(function(x){ return x.id === id; })[0];
    return v && v.stock !== null && v.policy === 'deny' ? Math.max(0, v.stock) : null;
  }
  function checkLimit(input, typed){
    var stepper = input.closest('[data-stepper]');
    if(!stepper) return;
    var stock = stockFor(input);
    if(stock === null){ limitNote(stepper, ''); return; }
    var value = Math.floor(+input.value) || 0;
    if(stock > 0 && value > stock){ input.value = stock; value = stock; }
    if(stock === 0) limitNote(stepper, input.hasAttribute('data-available') ? 'Sold out – please remove this item' : '');
    else if(value >= stock) limitNote(stepper, 'Only ' + stock + ' available');
    else limitNote(stepper, '');
  }
  // capture phase: clamp before the bag saves the new quantity
  document.addEventListener('input', function(e){
    if(e.target.matches && e.target.matches('[data-stepper] input')) checkLimit(e.target, true);
  }, true);
  document.addEventListener('change', function(e){
    if(e.target.matches && e.target.matches('[data-stepper] input')) checkLimit(e.target, true);
    if(e.target.matches && e.target.matches('[data-product-form] input[data-option-index]')){
      var q = document.querySelector('[data-product-form] [data-quantity]');
      if(q) setTimeout(function(){ checkLimit(q, false); }, 0);
    }
  });
  document.querySelectorAll('[data-stepper] input').forEach(function(input){ checkLimit(input, false); });

  // bag: lines already above the stock (e.g. typed earlier) are brought down once
  var cartFormEl = document.querySelector('[data-cart-form]');
  if(cartFormEl){
    var fixes = {};
    var needsFix = false;
    cartFormEl.querySelectorAll('input[data-available]').forEach(function(input){
      var stock = +input.getAttribute('data-available');
      var key = (input.name.match(/^updates\[(.+)\]$/) || [])[1];
      if(!key || stock < 1) return;
      var inCart = +input.getAttribute('value');
      if(inCart > stock){
        fixes[key] = stock;
        needsFix = true;
      }
    });
    if(needsFix && !store(function(){ return sessionStorage.getItem('bh:stock-fix'); })){
      store(function(){ sessionStorage.setItem('bh:stock-fix', '1'); });
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: fixes })
      }).then(function(){ location.reload(); }, function(){});
    } else if(!needsFix){
      store(function(){ sessionStorage.removeItem('bh:stock-fix'); });
    }
  }

  // product page: add without leaving the page when the bag would go past the stock
  var productForm = document.querySelector('[data-product-form]');
  if(productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = productForm.querySelector('[data-add-button]');
      var err = productForm.querySelector('[data-form-error]');
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if(btn) btn.disabled = true;
      if(err) err.hidden = true;
      var body = new FormData(productForm);
      var variantId = +body.get('id');
      var wanted = Math.max(1, Math.floor(+body.get('quantity')) || 1);
      var v = pdpData && pdpData.variants.filter(function(x){ return x.id === variantId; })[0];
      var stock = v && v.stock !== null && v.policy === 'deny' ? Math.max(0, v.stock) : null;
      // Shopify only checks the amount being added, so count what is already in the bag first
      (stock === null ? Promise.resolve(0) : fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(x){ return x.json(); })
        .then(function(cart){
          return cart.items.reduce(function(sum, item){ return item.variant_id === variantId ? sum + item.quantity : sum; }, 0);
        }, function(){ return 0; }))
        .then(function(inBag){
          if(stock !== null && inBag + wanted > stock){
            var room = Math.max(0, stock - inBag);
            if(room === 0){
              return { ok: false, json: { description: 'Only ' + stock + ' available, and all ' + stock + ' are already in your bag.' } };
            }
            body.set('quantity', String(room));
          }
          return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
            .then(function(res){ return res.json().then(function(json){ return { ok: res.ok, json: json }; }); });
        })
        .then(function(r){
          if(r.ok){ location.href = root + 'cart'; return; }
          if(err){ err.textContent = r.json.description || r.json.message || 'Could not add to bag'; err.hidden = false; }
          if(btn) btn.disabled = false;
          // refresh the bag count; a failure here must not fall through to the native re-submit below
          fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(x){ return x.json(); }).then(function(cart){
            document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count); el.hidden = !cart.item_count; });
          }).catch(function(){});
        })
        .catch(function(){ HTMLFormElement.prototype.submit.call(productForm); });
    });
  }

  /* ---------- cookie banner → Shopify Customer Privacy API ---------- */
  var COOKIE_KEY = 'bh:cookie-consent';
  var cookieDone = false;
  function finishCookies(){
    if(cookieDone) return;
    cookieDone = true;
    document.dispatchEvent(new CustomEvent('bh:cookies-done'));
  }
  function withPrivacy(cb){
    var called = false;
    function once(api){ if(called) return; called = true; cb(api); }
    if(window.Shopify && Shopify.customerPrivacy) return once(Shopify.customerPrivacy);
    if(window.Shopify && typeof Shopify.loadFeatures === 'function'){
      setTimeout(function(){ once(null); }, 4000);
      try {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
          once(err ? null : (window.Shopify.customerPrivacy || null));
        });
      } catch(e){ once(null); }
    } else {
      once(null);
    }
  }
  function sendConsent(yes){
    withPrivacy(function(api){
      if(!api || typeof api.setTrackingConsent !== 'function') return;
      var noop = function(){};
      try {
        api.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, noop);
      } catch(e){
        try { api.setTrackingConsent(yes, noop); } catch(e2){}
      }
    });
  }
  function visitorHasChosen(api){
    try {
      if(typeof api.currentVisitorConsent === 'function'){
        var c = api.currentVisitorConsent() || {};
        return ['analytics', 'marketing', 'preferences'].some(function(k){ return c[k] === 'yes' || c[k] === 'no'; });
      }
      if(typeof api.getTrackingConsent === 'function') return api.getTrackingConsent() !== 'no_interaction';
    } catch(e){}
    return false;
  }

  var cookieBanner = document.querySelector('[data-cookie-banner]');
  if(cookieBanner){
    var cookiePreview = cookieBanner.getAttribute('data-preview') === 'true';
    var cookieAudience = cookieBanner.getAttribute('data-audience');
    var savedChoice = store(function(){ return localStorage.getItem(COOKIE_KEY); }, null);

    var showCookies = function(){
      cookieBanner.hidden = false;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ cookieBanner.classList.add('is-visible'); }); });
    };
    var hideCookies = function(){
      cookieBanner.classList.remove('is-visible');
      setTimeout(function(){ cookieBanner.hidden = true; }, reduceMotion ? 0 : 260);
      finishCookies();
    };

    cookieBanner.addEventListener('click', function(e){
      var btn = e.target.closest && e.target.closest('[data-cookie-choice]');
      if(!btn) return;
      var yes = btn.getAttribute('data-cookie-choice') === 'yes';
      if(!cookiePreview) store(function(){ localStorage.setItem(COOKIE_KEY, yes ? 'yes' : 'no'); });
      sendConsent(yes);
      hideCookies();
    });

    if(cookiePreview){
      showCookies();
      finishCookies(); // don't hold back the newsletter pop-up while previewing
    } else {
      withPrivacy(function(api){
        if(savedChoice){
          if(api && !visitorHasChosen(api)) sendConsent(savedChoice === 'yes');
          return finishCookies();
        }
        if(api){
          if(visitorHasChosen(api)) return finishCookies();
          if(cookieAudience === 'required' && typeof api.shouldShowBanner === 'function' && !api.shouldShowBanner()) return finishCookies();
          return showCookies();
        }
        if(cookieAudience === 'required') return finishCookies();
        showCookies();
      });
    }
  } else {
    finishCookies();
  }

  /* ---------- newsletter pop-up ---------- */
  var nl = document.getElementById('NewsletterPopup');
  if(!nl) return;

  var NL_KEY = 'bh:newsletter';
  var NL_SUBMITTED = 'bh:newsletter-submitted';
  var nlPreview = nl.getAttribute('data-preview') === 'true';
  var nlState = store(function(){ return JSON.parse(localStorage.getItem(NL_KEY) || 'null'); }, null) || {};
  var nlPanel = nl.querySelector('[role="dialog"]');
  var nlForm = document.getElementById('NewsletterPopupForm');
  var nlFormView = nl.querySelector('[data-nl-view="form"]');
  var nlSuccessView = nl.querySelector('[data-nl-view="success"]');
  var nlError = nl.querySelector('[data-nl-error]');
  var nlSubmit = nl.querySelector('[data-nl-submit]');
  var nlEmail = nl.querySelector('input[type="email"]');
  var nlOpened = false;
  var nlSubscribed = false;
  var nlReturnFocus = null;

  function saveNl(patch){
    if(nlPreview) return;
    for(var k in patch) nlState[k] = patch[k];
    store(function(){ localStorage.setItem(NL_KEY, JSON.stringify(nlState)); });
  }
  function otherDialogOpen(){
    return Array.prototype.some.call(document.querySelectorAll('[data-modal]'), function(m){ return !m.hidden; });
  }
  function openNl(force){
    if(nlOpened) return;
    if(!force && otherDialogOpen()){ setTimeout(function(){ openNl(false); }, 4000); return; }
    nlOpened = true;
    nlReturnFocus = document.activeElement;
    nl.hidden = false;
    htmlEl.classList.add('scroll-lock');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        nl.classList.add('is-open');
        nlPanel.focus({ preventScroll: true });
      });
    });
  }
  function closeNl(){
    if(nl.hidden) return;
    nl.classList.remove('is-open');
    if(!otherDialogOpen()) htmlEl.classList.remove('scroll-lock');
    if(!nlSubscribed) saveNl({ closed: Date.now() });
    setTimeout(function(){
      if(nl.classList.contains('is-open')) return;
      nl.hidden = true;
      if(!otherDialogOpen()) htmlEl.classList.remove('scroll-lock');
    }, reduceMotion ? 0 : 320);
    if(nlReturnFocus && nlReturnFocus.focus && document.contains(nlReturnFocus)) nlReturnFocus.focus({ preventScroll: true });
  }
  function showSuccess(){
    nlSubscribed = true;
    nlFormView.hidden = true;
    nlSuccessView.hidden = false;
    saveNl({ subscribed: Date.now() });
    var t = nlSuccessView.querySelector('.nl-title');
    if(t){ t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
  }
  function showError(message){
    nlError.textContent = message;
    nlError.hidden = false;
    nlEmail.setAttribute('aria-invalid', 'true');
    nlEmail.focus();
  }

  nl.addEventListener('click', function(e){
    if(e.target.closest('[data-nl-close]')){ closeNl(); return; }
    var copy = e.target.closest('[data-nl-copy]');
    if(!copy) return;
    var code = copy.getAttribute('data-nl-copy');
    var done = function(){
      var tag = copy.querySelector('span');
      if(tag){ tag.textContent = 'Copied'; setTimeout(function(){ tag.textContent = 'Copy'; }, 2000); }
    };
    if(navigator.clipboard && window.isSecureContext){
      navigator.clipboard.writeText(code).then(done, function(){ prompt('Copy this code', code); });
    } else {
      prompt('Copy this code', code);
    }
  });

  document.addEventListener('keydown', function(e){
    if(nl.hidden) return;
    if(e.key === 'Escape'){ e.preventDefault(); closeNl(); return; }
    if(e.key !== 'Tab') return;
    var list = Array.prototype.filter.call(
      nlPanel.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled])'),
      function(n){ return n.offsetParent !== null; }
    );
    if(!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if(e.shiftKey && (document.activeElement === first || !nlPanel.contains(document.activeElement))){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  /* the announcement pop-up has no form; everything below is optional */
  if(nlEmail && nlError) nlEmail.addEventListener('input', function(){ nlError.hidden = true; nlEmail.removeAttribute('aria-invalid'); });

  if(nlForm) nlForm.addEventListener('submit', function(e){
    if(nlForm.getAttribute('data-native') === 'true') return;
    e.preventDefault();
    nlError.hidden = true;
    var label = nlSubmit.textContent;
    nlSubmit.disabled = true;
    nlSubmit.textContent = 'Please wait…';
    var restore = function(){ nlSubmit.disabled = false; nlSubmit.textContent = label; };
    var nativeSubmit = function(){
      store(function(){ sessionStorage.setItem(NL_SUBMITTED, '1'); });
      nlForm.setAttribute('data-native', 'true');
      HTMLFormElement.prototype.submit.call(nlForm);
    };
    fetch(nlForm.action, { method: 'POST', body: new FormData(nlForm), headers: { 'Accept': 'text/html' } })
      .then(function(res){
        if(/challenge/.test(res.url)) return nativeSubmit();
        if(/customer_posted=true/.test(res.url)){ restore(); return showSuccess(); }
        return res.text().then(function(html){
          var tpl = document.createElement('template');
          tpl.innerHTML = html;
          var serverError = tpl.content.querySelector('#NewsletterPopupError:not([hidden])');
          var errText = serverError && serverError.textContent.trim();
          if(errText){ restore(); return showError(errText); }
          if(tpl.content.querySelector('#NewsletterPopupForm [data-nl-posted]')){ restore(); return showSuccess(); }
          // no success or error marker in the reply: let the browser post it normally
          nativeSubmit();
        });
      })
      .catch(nativeSubmit);
  });

  // came back from a normal (non-fetch) form post
  if(nlForm && store(function(){ return sessionStorage.getItem(NL_SUBMITTED); }, null)){
    store(function(){ sessionStorage.removeItem(NL_SUBMITTED); });
    if(nl.querySelector('[data-nl-posted]')){ showSuccess(); openNl(true); return; }
    if(nlError && !nlError.hidden){ openNl(true); return; }
  } else if(nlForm){
    // the post came from the footer sign-up (both forms share Shopify's customer form state)
    if(nl.querySelector('[data-nl-posted]')) saveNl({ subscribed: Date.now() });
    if(nlError) nlError.hidden = true;
  }

  var days = parseInt(nl.getAttribute('data-days'), 10) || 7;
  /* a new announcement is a new message: someone who dismissed last week's offer
     should still see this week's, so the countdown only holds while the wording
     and the photos stay the same */
  var version = nl.getAttribute('data-v') || '';
  if(version && nlState.v !== version){
    nlState = { v: version };
    saveNl({ v: version });
  }
  var eligible = nlPreview || !(nlState.subscribed || (nlState.closed && Date.now() - nlState.closed < days * 864e5));
  if(!nlPreview && nl.getAttribute('data-mobile') === 'false' && window.innerWidth < 750) eligible = false;
  if(!eligible) return;

  function startNl(){
    var delay = nlPreview ? 600 : (parseInt(nl.getAttribute('data-delay'), 10) || 0) * 1000;
    setTimeout(function(){ openNl(nlPreview); }, delay);
    if(!nlPreview && nl.getAttribute('data-exit') === 'true' && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches){
      var onLeave = function(e){
        if(e.relatedTarget || e.clientY > 0) return;
        document.removeEventListener('mouseout', onLeave);
        openNl(false);
      };
      setTimeout(function(){ document.addEventListener('mouseout', onLeave); }, 3000);
    }
  }
  if(cookieDone || nlPreview) startNl();
  else document.addEventListener('bh:cookies-done', startNl, { once: true });
})();
